import { createSlice, createSelector, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

interface QlikFieldState {
  // qlikFieldDefs: Record<string, any>;
  qlikFieldObjects: Record<string, any>;
  qlikFieldsValList: Record<string, any>;
}

const initialState: QlikFieldState = {
  // qlikFieldDefs: {},
  qlikFieldObjects: [],
  qlikFieldsValList: {},
};

const qlikFieldSlice = createSlice({
  name: "qlikField",
  initialState,
  reducers: {
    // setQlikFieldDefs(state, action: PayloadAction<Record<string, any>>) {
    //   state.qlikFieldDefs = action.payload;
    // },
    setQlikFieldValList(
      state,
      action: PayloadAction<{ name: string; appName: string, fieldValues: any, objectId: string }>
    ) {
        const { name, appName, fieldValues, objectId } = action.payload;
        state.qlikFieldsValList = {
            ...state.qlikFieldsValList,
            [appName]: {
              ...(state.qlikFieldsValList[appName] || {}),
              [name]: fieldValues
            }
        };
        if(state.qlikFieldsValList?.objectIds === undefined) {
          state.qlikFieldsValList.objectIds = []
        };
        if (!state.qlikFieldsValList.objectIds.includes(objectId)) {
          state.qlikFieldsValList.objectIds.push(objectId);
        }
    },
    setQlikFieldObject(
      state,
      action: PayloadAction<{ name: string; appName: string }>
    ) {
      state.qlikFieldObjects.push({
        name: action.payload.name,
        app: action.payload.appName
      });
    },
  }
});

export const {
  // setQlikFieldDefs,
  setQlikFieldValList,
  setQlikFieldObject,
} = qlikFieldSlice.actions;

export default qlikFieldSlice.reducer;

const selectQlikFieldObjects = (state: RootState) => state.qlikFields.qlikFieldObjects;

// Selector to filter qlikFieldObjects by name and app
export const getFilteredQlikFieldObjects = createSelector(
  [selectQlikFieldObjects, (_: RootState, name: string) => name, (_: RootState, __: string, app: string) => app],
  (qlikFieldObjects, name, app) => {
    return qlikFieldObjects.filter((field: any) => field.name === name && field.app === app);
  }
);

export type { QlikFieldState };